/**
 * Shared WhatsApp deeplink helpers.
 *
 * Mirrors the battle-tested logic in WhatsAppDeeplinkButton.tsx:
 * - Desktop goes straight to web.whatsapp.com (avoids the
 *   "whatsapp:// scheme not registered" error on PCs without the app)
 * - Mobile uses wa.me with same-window navigation (avoids popup blocking)
 */

export function isMobile(): boolean {
  if (typeof navigator === 'undefined') return false;
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (typeof window !== 'undefined' &&
      window.matchMedia != null &&
      window.matchMedia('(pointer: coarse)').matches)
  );
}

export function buildWhatsAppUrl(phone: string, message: string, desktop = false): string {
  if (desktop) {
    return `https://web.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
  }
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
